import { ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import {
  Colors,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { SponsorshipCard } from './SponsorshipCard';
import { SponsorshipPersonCard } from './SponsorshipPersonCard';

type Person = {
  name: string;
  title: string;
  initials?: string;
};

type Props = {
  requester: Person;
  target: Person;
};

export function IntroRequestCard({ requester, target }: Props) {
  const styles = useDynamicStyles(createStyles);

  return (
    <SponsorshipCard style={styles.container}>
      <SponsorshipPersonCard
        name={requester.name}
        title={requester.title}
        initials={requester.initials}
        align="left"
      />
      <View style={styles.chevronContainer}>
        <HugeiconsIcon
          icon={ArrowRight01Icon}
          color={Colors.opacity50}
          size={20}
        />
      </View>
      <SponsorshipPersonCard
        name={target.name}
        title={target.title}
        initials={target.initials}
        align="right"
      />
    </SponsorshipCard>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: isMobile ? 8 : 16,
    },
    chevronContainer: {
      paddingHorizontal: isMobile ? 4 : 8,
    },
  });
